let currTop = 0;
let w = document.documentElement.clientWidth;
// window.onscroll = function() {
//     let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
//     if(w > 1000){
//       if (scrollTop > currTop) {
//         if (!document.querySelector(".header-new").classList.contains("hideHeader")) {
//             document.querySelector(".header-new").classList.add("hideHeader");
//         }
//     } else {
//         document.querySelector(".header-new").classList.remove("hideHeader");
//     }
//     }
//     currTop = scrollTop;
// }
if (document.querySelector("#t4s-snow_ef")) {
  setTimeout(function () {
    document.querySelector("#t4s-snow_ef").style.display = "none";
  }, 10000);
}

window.addEventListener("load", function () {
  $(".discountNotice").fadeIn();
  $(".discountNotice-head").click(function () {
    $(this).parent().toggleClass("active");
    if ($(this).parent().hasClass("active")) {
      $(this).parent().find(".discountNotic-content").slideDown();
    } else {
      $(this).parent().find(".discountNotic-content").slideUp();
    }
  });
  $(".discountNotic-item-bottom-btn").click(function () {
    $(this)
      .parents(".discountNotic-item-bottom")
      .find(".discountNotic-item-detailPop")
      .fadeIn();
  });
  $(".discountNotic-item-bottom-btn-m").click(function () {
    let id = $(this).data("id");
    $(".discountNotic-item-detailPop-" + id).fadeIn();
  });
  $(".close_detailPop").click(function (e) {
    e.stopPropagation();
    $(this).parents(".discountNotic-item-detailPop").fadeOut();
  });
  $(".discountNotic-item-detailPop").click(function (e) {
    e.stopPropagation();
  });
  $(".discountNotic-top-btn").click(function () {
    let code = $(this).data("code");
    copy(code);
    $(this).parents(".discountNotic-item-top").addClass("success");
  });
});
function copyCode(t, code) {
  var text = code;
  var input = document.createElement("input");
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  $(t).parents(".newsletter-success-new").find(".newsletter-copy").hide();
  $(t).parents(".newsletter-success-new").find(".newsletter-copied").show();
}

function copy(code) {
  var text = code;
  var input = document.createElement("input");
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
}
